{
    "0": {
        "en-CA": "N/A",
        "fr-CA": "S/O"
    },
    "1": {
        "en-CA": "E-mail",
        "fr-CA": "Courriel"
    },
    "2": {
        "en-CA": "Pick up",
        "fr-CA": "Cueillette"
    },
    "3": {
        "en-CA": "Hand delivered",
        "fr-CA": "En personne"
    },
    "4": {
        "en-CA": "Mail",
        "fr-CA": "Poste"
    },
    "5": {
        "en-CA": "Courier",
        "fr-CA": "Messagerie"
    },
    "6": {
        "en-CA": "USB key",
        "fr-CA": "Clé USB"
    },
    "7": {
        "en-CA": "CD-ROM",
        "fr-CA": "Cédérom"
    },
    "8": {
        "en-CA": "Portal",
        "fr-CA": "Portail"
    },
    "9": {
        "en-CA": "Other",
        "fr-CA": "Autre"
    },
    "10": {
        "en-CA": "None",
        "fr-CA": "Aucune"
    }
}
